import React, { useState } from 'react';
import axios from 'axios';
import { Button } from "primereact/button";
import { ProgressSpinner } from 'primereact/progressspinner';
import './sentenceSearcher.css';

const SentenceSearcher = () => {
    const [sentence, setSentence] = useState("");
    const [loading, setLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);

    const handleSearch = async () => {
        if (!sentence.trim()) {
            alert("Please enter a sentence to search.");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_SENTENCE_SCANNER,
                { sentence },
                { responseType: 'blob' }
            );

            const downloadUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'sentence-search-output.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error during sentence scan:', error);
            alert("An error occurred while processing your request. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleExportErrors = async () => {
        setExportLoading(true);
        try {
            const response = await axios.get(
                process.env.REACT_APP_SUBTITLE_SYNC_LOG,
                { responseType: 'blob' }
            );

            const downloadUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'subtitle-sync-log.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error during export:', error);
            alert("An error occurred while exporting errors. Please try again.");
        } finally {
            setExportLoading(false);
        }
    };

    return (
        <div className="grid">
            <div className="col-12">
                <div className="container">
                    <div className="field-search">
                        <label htmlFor="sentenceInput">
                            Search for Scene:
                        </label>
                        <input
                            type="text"
                            id="sentenceInput"
                            value={sentence}
                            onChange={(e) => setSentence(e.target.value)}
                            placeholder="Enter a sentence"
                        />
                        <div className="button-container">
                            <Button
                                type="button"
                                label="Search"
                                icon="pi pi-search"
                                className="p-button-info button-search"
                                onClick={handleSearch}
                                disabled={loading}
                            />
                            {loading && (
                                <ProgressSpinner
                                    style={{ width: '50px', height: '50px' }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration=".5s"
                                />
                            )}
                        </div>
                        <div className="field-search">
                            <div className="log-errors-section" style={{ marginTop: '30px' }}>
                                <label htmlFor="logErrors" style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                                    Export last processing errors:
                                </label>
                                <Button
                                    type="button"
                                    label="Export"
                                    icon="pi pi-file-excel"
                                    className="p-button-success button-export"
                                    onClick={handleExportErrors}
                                    disabled={exportLoading}
                                />
                                {exportLoading && (
                                    <ProgressSpinner
                                        style={{ width: '50px', height: '50px', marginTop: '10px' }}
                                        strokeWidth="8"
                                        fill="var(--surface-ground)"
                                        animationDuration=".5s"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SentenceSearcher;
